import React from 'react'
import { useTranslation } from 'react-i18next'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import MedconnectDeviceCard, { MedconnectDeviceCardProps } from './MedconnectDeviceCard'

export type MedconnectDevicesProps = {
  devices: MedconnectDeviceCardProps[]
}


// shows devices that can not be access by navigator API and are present on the connector installed on the computer
export default function MedconnectDevices(props: MedconnectDevicesProps) {
  const { devices } = props
  const { t } = useTranslation()

  if (devices.length === 0) {
    return (
      <Grid container justifyContent="center">
        <Grid item xs={12}>
          <h3>{t('component.ui.MedconnectDevice.noDevices')}</h3>
        </Grid>
      </Grid>
    )
  }

  return (
    <Box>
      <Typography variant="h5" sx={{ fontSize: '24px', fontWeight: 'bold', lineHeight: '24px', mb: '38px' }}>
        {t('component.ui.MedconnectDevice.subtitle')}
      </Typography>
      <Grid container spacing={4}>
        {devices.map((device, index) => (
          <Grid item xs={12} md={6} key={device.name+'-'+index} >
            <MedconnectDeviceCard {...device} />
          </Grid>
        ))}
      </Grid>
    </Box>
  )
}